
import { useParams } from 'react-router-dom';
import { RamosFormState } from '../../../context/ramos/RamosFormState';
import { Form } from './form';
import useDocumentTitle from '../../../components/Title';

export const RamosFormPage = () => {
  const { id } = useParams();
  const title = id ? "Editar Ramo" : "Crear Ramo";
  useDocumentTitle(title);

  return (
    <RamosFormState>
        <Form title={title} />
    </RamosFormState>
  );
};
